// ─── Open / Close ────────────────────────────────────────────────
function scmOpenModal(backdrop) {
  backdrop.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function scmCloseModal(backdrop) {
  backdrop.classList.remove('is-open');
  document.body.style.overflow = '';
}

// ─── Init ────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const backdrop = document.getElementById('scm-backdrop');
  const form = backdrop && backdrop.querySelector('.scm-form');
  if (!backdrop || !form) return;

  const countrySelect = document.getElementById('scm-country-select');
  const languageSelect = document.getElementById('scm-language-select');
  const countryInput = form.querySelector('input[name="country_code"]');
  const localeInput = form.querySelector('input[name="locale_code"]');

  document.querySelectorAll('[data-scm-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () { scmOpenModal(backdrop); });
  });

  backdrop.addEventListener('click', function (e) {
    if (e.target === backdrop) scmCloseModal(backdrop);
  });

  backdrop.querySelectorAll('[data-scm-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { scmCloseModal(backdrop); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && backdrop.classList.contains('is-open')) scmCloseModal(backdrop);
  });

  form.addEventListener('submit', function () {
    if (countrySelect && countryInput) countryInput.value = countrySelect.value;
    if (languageSelect && localeInput) localeInput.value = languageSelect.value;
  });
});
